import { BaseEnum } from './BaseEnum';

export class CareTeamMemberType extends BaseEnum {
  static readonly FAMILY_FRIEND: string = 'FAMILY';

  static readonly AIDE: string = 'AIDE';

  static readonly PROVIDER: string = 'PROVIDER';

  static readonly OTHER: string = 'OTHER';

  static readonly SORT_ORDER = new Map<string, number>([
    [CareTeamMemberType.AIDE, 1],
    [CareTeamMemberType.FAMILY_FRIEND, 2],
    [CareTeamMemberType.PROVIDER, 3],
    [CareTeamMemberType.OTHER, 4],
  ]);
}

export default CareTeamMemberType;
